import { Link } from 'react-router-dom';
import TagBadge from './TagBadge';
import { Calendar, Clock } from 'lucide-react';

const PLACEHOLDER_BG = {
  Backend: 'bg-emerald-50 dark:bg-emerald-950/50',
  Frontend: 'bg-indigo-50 dark:bg-indigo-950/50',
  Azure: 'bg-blue-50 dark:bg-blue-950/50',
  DevOps: 'bg-orange-50 dark:bg-orange-950/50',
  General: 'bg-gray-50 dark:bg-gray-900',
};

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
  });
}

export default function PostCard({ post }) {
  const bg = PLACEHOLDER_BG[post.category] || PLACEHOLDER_BG.General;

  return (
    <Link
      to={`/posts/${post.slug}`}
      data-testid={`post-card-${post.slug}`}
      className="group block h-full"
    >
      <article className="h-full rounded-lg border border-border bg-card overflow-hidden hover:border-primary/40 hover:shadow-md transition-all duration-300">
        {/* Cover */}
        <div className="aspect-video overflow-hidden">
          {post.cover_image ? (
            <img
              src={post.cover_image}
              alt={post.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <div className={`w-full h-full ${bg} flex items-center justify-center`}>
              <span className="text-3xl font-bold font-mono text-muted-foreground/20 select-none">
                {'</>'}
              </span>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-5">
          <div className="mb-3">
            <TagBadge tag={post.category} />
          </div>
          <h2
            className="text-base font-bold leading-snug mb-2 group-hover:text-primary/80 transition-colors line-clamp-2"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            {post.title}
          </h2>
          {post.excerpt && (
            <p className="text-sm text-muted-foreground line-clamp-2 mb-4">
              {post.excerpt}
            </p>
          )}
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <span className="flex items-center gap-1">
              <Calendar className="h-3 w-3" />
              {formatDate(post.created_at)}
            </span>
            <span className="flex items-center gap-1">
              <Clock className="h-3 w-3" />
              {post.reading_time} min read
            </span>
          </div>
          {post.tags?.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-3">
              {post.tags.slice(0, 3).map(t => (
                <TagBadge key={t} tag={t} />
              ))}
            </div>
          )}
        </div>
      </article>
    </Link>
  );
}
